import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { ThemeProvider, createTheme } from '@material-ui/core/styles';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-103349547-3');
ReactGA.pageview(window.location.pathname + window.location.search);

const theme = createTheme({
  palette:{
    primary: {
      main: "#5BA8EF",
      contrastText:"#FFF"
    }
  },
})

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root') as HTMLElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
